import { Grid, Card, Box, Typography } from '@mui/material';
import { FitnessCenter, AccessTime, Done } from '@mui/icons-material';
import { t } from 'i18next';
import PatientPlans from './PatientPlans';

export default function UserStats({
    groups,
    plans,
    totalExercises,
    totalSkipped,
    onSelectPlan,
    selectedPlan
}) {
    const stats = [
        {
            icon: <FitnessCenter sx={{ fontSize: 44, color: '#1976d2' }} />,
            value: totalExercises + totalSkipped,
            label: t('plans.totalExercises')
        },
        {
            icon: <Done sx={{ fontSize: 44, color: '#1976d2' }} />,
            value: totalExercises,
            label: t('plans.completedExercises')
        },
        {
            icon: <AccessTime sx={{ fontSize: 44, color: '#1976d2' }} />,
            value: totalSkipped,
            label: t('plans.notPerformed')
        }
    ];

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={3}>
                <PatientPlans plans={plans} onSelectPlan={onSelectPlan} />
            </Grid>

            {stats.map((stat, i) => (
                <Grid item xs={12} sm={6} md={3} key={i}>
                    <Card
                        elevation={3}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 2,
                            borderRadius: 3,
                            backgroundColor: '#f9f9f9'
                        }}
                    >
                        <Box mr={2} mt={1} mb={1}>
                            {stat.icon}
                        </Box>
                        <Box mt={1} mb={1}>
                            <Typography variant="h5" fontWeight={600}>
                                {stat.value}
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                {stat.label}
                            </Typography>
                        </Box>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
}
